/**
 * API Configuration - Uses centralized domain management
 */

import { domainManager, getCurrentEnvironment } from './domains'

// Environment detection
const isDevelopment = import.meta.env.DEV
const isProduction = import.meta.env.PROD
const environment = getCurrentEnvironment()

// Get URLs from centralized domain manager
const domainConfig = domainManager.getEnvironmentInfo()

// Export configuration
export const apiConfig = {
  baseURL: domainManager.getApiBaseUrl(),
  timeout: 30000, // 30 seconds
  retryAttempts: 3,
  retryDelay: 1000, // 1 second
  
  // Headers
  defaultHeaders: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
}

// TiendaNube configuration - All URLs from domain manager
export const tiendanubeConfig = {
  appId: import.meta.env.VITE_TIENDANUBE_APP_ID || '20544',
  redirectUri: domainManager.getOAuthCallbackUrl(),
  authUrl: 'https://www.tiendanube.com/apps/authorize/token',
  // OAuth endpoints use same-origin
  authInitiateUrl: `${domainManager.getApiBaseUrl()}/auth`,
  callbackUrl: `${domainManager.getApiBaseUrl()}/callback`
}

// Feature flags
export const featureFlags = {
  enableDebugMode: import.meta.env.VITE_ENABLE_DEBUG_MODE === 'true' || isDevelopment,
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true' && isProduction,
  enableOfflineMode: import.meta.env.VITE_ENABLE_OFFLINE_MODE === 'true'
}

// Tracking configuration - URL from domain manager
export const trackingConfig = {
  scriptUrl: domainManager.getTrackingScriptUrl(),
  debugMode: featureFlags.enableDebugMode
}

// App configuration
export const appConfig = {
  title: import.meta.env.VITE_APP_TITLE || 'TN-Xperiment',
  companyName: import.meta.env.VITE_COMPANY_NAME || 'ECommerceLab Agency',
  environment,
  version: '1.0.0'
}

// Logging configuration
export const logConfig = {
  level: isDevelopment ? 'debug' : 'warn',
  enableConsoleLogging: isDevelopment,
  enableRemoteLogging: isProduction
}

// Export environment info
export const environmentInfo = {
  isDevelopment,
  isProduction,
  environment,
  buildTime: new Date().toISOString(),
  domainConfig
}

// Debug logging - Always show domain configuration
console.group('🔧 Frontend Configuration')
console.log('Environment:', environment)
console.log('Domain Config:', domainConfig)
console.log('API Base URL:', apiConfig.baseURL)
console.log('TiendaNube Redirect URI:', tiendanubeConfig.redirectUri)
console.log('Feature Flags:', featureFlags)
console.log('Build Time:', environmentInfo.buildTime)
console.groupEnd()